import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {NumberPipe} from '@brunata-angular/ui';
import {StepStatus} from '../step-focus/step-state.model';
import {ExportLimits, noExportLimits, stepMenuLimits} from '../step-menu/export-limits.model';
import {FlowStep, StepMenuFlowComponent} from './step-menu-flow.component';

@Component({
    selector: 'app-step-flow',
    standalone: true,
    imports: [StepMenuFlowComponent],
    template: `
        <app-step-menu-flow
            [steps]="steps()"
            [headingKey]="headingKey()"
            [limits]="menuLimits()"
            [statuses]="statuses()">
            <ng-content />
        </app-step-menu-flow>
    `,
    styles: `
        :host {
            display: block;
            counter-reset: step;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [NumberPipe],
})
export class StepFlowComponent {
    readonly steps = input.required<ReadonlyArray<FlowStep>>();
    readonly headingKey = input.required<string>();
    readonly limits = input<ExportLimits>(noExportLimits);
    readonly statuses = input<ReadonlyMap<string, StepStatus>>(new Map());

    private readonly numberPipe = inject(NumberPipe);

    protected readonly menuLimits = computed(() =>
        stepMenuLimits(this.limits(), value => this.numberPipe.transform(value)),
    );
}
